import { render, staticRenderFns } from "./PricingTable.vue?vue&type=template&id=afb10498&"
import script from "./PricingTable.vue?vue&type=script&lang=ts&"
export * from "./PricingTable.vue?vue&type=script&lang=ts&"
import style0 from "./PricingTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports